/**
 * values for setting the 'format' in address fields
 */

const MX_POLL_DISPLAY = {
  NONE:       'none',
  PERCENTAGE: 'percentage',
  COUNT:      'count',
};

const MX_POLL_DISPLAY_ALL = _.values(MX_POLL_DISPLAY, 'value');

const MX_POLL_DISPLAY_LIST = [
  { label: 'Do not display real-time results', value: MX_POLL_DISPLAY.NONE, description: '' },
  { label: 'Display real-time results as percentage', value: MX_POLL_DISPLAY.PERCENTAGE, description: '' },
  { label: 'Display real-time results as total count', value: MX_POLL_DISPLAY.COUNT, description: '' },
];

const MX_POLL_RESULTS_DISPLAY_LIST = [
  { label: 'Do not display values on chart', value: MX_POLL_DISPLAY.NONE, description: '' },
  { label: 'Display percentages on chart', value: MX_POLL_DISPLAY.PERCENTAGE, description: '' },
  { label: 'Display counts on chart', value: MX_POLL_DISPLAY.COUNT, description: '' },
];

export { MX_POLL_DISPLAY, MX_POLL_DISPLAY_LIST, MX_POLL_RESULTS_DISPLAY_LIST, MX_POLL_DISPLAY_ALL };

export default MX_POLL_DISPLAY;
